import { DEMO, SAMPLE_SOURCE } from '@trips/shared/fixtures/demo';
import { put, remove } from './mutate';
import { getState } from './store';

/** Adds the sample trips to your real data, so the design can be tried with something in it. */
export async function loadSampleTrips() {
  const { tables } = getState();
  for (const p of DEMO.places) if (!tables.places.has(p.id)) await put('places', p);
  for (const t of DEMO.trips) await put('trips', { ...t, createdAt: undefined });
  for (const i of DEMO.items)
    await put('items', { ...i, sourceId: SAMPLE_SOURCE, createdAt: undefined });
}

export function hasSampleTrips(): boolean {
  for (const i of getState().tables.items.values())
    if (!i.deleted && i.sourceId === SAMPLE_SOURCE) return true;
  return false;
}

/** Removes every sample plan, and trips left with nothing else in them. */
export async function removeSampleTrips() {
  const { tables } = getState();
  const touched = new Set<string>();
  for (const i of tables.items.values()) {
    if (i.deleted || i.sourceId !== SAMPLE_SOURCE) continue;
    if (i.tripId) touched.add(i.tripId);
    await remove('items', i.id);
  }
  const after = getState().tables;
  for (const tripId of touched) {
    const left = [...after.items.values()].some((i) => !i.deleted && i.tripId === tripId);
    if (!left) await remove('trips', tripId);
  }
}
